import { Box } from '@mui/material';
import { TextSpan } from '../../../Atoms/Text';
import { DEFAULT_LINK_BUTTON_STYLE } from '../../../../utils/styleHelpers';

export interface ZeroBaselineSkipProps {
  skipped: boolean;
  canEdit: boolean;
  onSkip: (skipped: boolean) => void;
}

export const ZeroBaselineSkip = ({ skipped, canEdit, onSkip }: ZeroBaselineSkipProps) => {
  if (!skipped && !canEdit) return null;
  return (
    <Box className="flex items-center gap-1">
      <TextSpan
        size="sm"
        color="grey6">
        {skipped ? 'No current supplier — $0 baseline' : 'No current supplier for this scope?'}
      </TextSpan>
      {canEdit && (
        <button
          type="button"
          className={DEFAULT_LINK_BUTTON_STYLE}
          onClick={() => onSkip(!skipped)}>
          {skipped ? 'Undo' : 'Skip with a $0 baseline'}
        </button>
      )}
    </Box>
  );
};
